import { categories, subjects } from './types.ts';
import type { Progress } from './types.ts';
const record = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
const date = (value: unknown): value is string =>
  typeof value === 'string' &&
  /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  !Number.isNaN(Date.parse(`${value}T00:00:00Z`));
export function validProgress(value: unknown): value is Progress {
  if (!record(value) || value.version !== 1) return false;
  if (
    !record(value.attempts) ||
    !record(value.drafts) ||
    !record(value.readingStarted) ||
    !record(value.completions) ||
    !Array.isArray(value.history)
  )
    return false;
  if (
    value.dailySubjects !== undefined &&
    (!record(value.dailySubjects) ||
      !Object.entries(value.dailySubjects).every(
        ([key, items]) =>
          date(key) &&
          Array.isArray(items) &&
          items.every((item) => subjects.includes(item)) &&
          new Set(items).size === items.length,
      ))
  )
    return false;
  for (const field of ['dailyConfirmed', 'dailyStamps']) {
    const values = value[field];
    if (
      values !== undefined &&
      (!record(values) ||
        !Object.entries(values).every(
          ([key, item]) =>
            date(key) &&
            (typeof item === 'boolean' ||
              (field === 'dailyStamps' && (item === 'sun' || item === 'moon'))),
        ))
    )
      return false;
  }
  return (
    Object.values(value.attempts).every(
      (item) =>
        record(item) &&
        Number.isInteger(item.tries) &&
        Number(item.tries) > 0 &&
        typeof item.correct === 'boolean' &&
        typeof item.lastAnswer === 'string',
    ) &&
    Object.values(value.drafts).every((item) => typeof item === 'string') &&
    Object.values(value.readingStarted).every((item) => typeof item === 'boolean') &&
    Object.entries(value.completions).every(
      ([key, items]) =>
        date(key) && Array.isArray(items) && items.every((item) => categories.includes(item)),
    ) &&
    value.history.every(
      (item) =>
        record(item) &&
        typeof item.questionId === 'string' &&
        typeof item.exerciseId === 'string' &&
        date(item.addedAt),
    )
  );
}
